module.exports = __webpack_public_path__ + "img/1.58f74ef4.png";